export const PROFILE_LOAD = 'w:Profile:load';
export const PROFILE_EDIT_CLICK = 'w:Profile:Edit:click';
export const PROFILE_EDIT_CANCEL = 'w:Profile:Edit:cancel';
export const PROFILE_EDIT_SAVE = 'w:Profile:Edit:save';
export const PROFILE_EDIT_ERROR = 'w:Profile:Edit:error';
export const PROFILE_VIEW = 'w:Profile:view';
